export default __webpack_public_path__ + "static/media/AvenirNextLTPro-MediumCn.be5d5c08.ttf";